module.exports = __webpack_public_path__ + "img/현대카드.beb38b24.png";